import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Card from './Card.jsx';

import { getCardByKey } from '../../../../selectors';
import {
    adminActions,
    uiActions
} from '../../../../actions';
import { sendEvent } from '../../../../../../methods';

class CardHOC extends Component {
    static defaultProps = { isAdmin: false }

    static propTypes = { apiUrl: PropTypes.string.isRequired }

    sendClickEvent = ({ asset_id }) => {
        sendEvent(this.props.apiUrl, {
            data: {
                asset_id
            },
            type: 'click'
        });
    }

    sendImageCarouselEvent = ({ asset_id, image_id }) => {
        // sendEvent({
        //     data: {
        //         asset_id,
        //         image_id
        //     },
        //     type: 'carousel_change'
        // });
    }

    render() {
        return (
            <Card
                sendImageCarouselEvent={this.sendImageCarouselEvent}
                sendClickEvent={this.sendClickEvent}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    activeVerticalId: state.activeVerticalId,
    adminTags: state.adminTags,
    apiUrl: state.config.apiUrl,
    card: getCardByKey(state, ownProps.cardId),
    config: state.config,
    currencySymbol: state.searchObject.currency_symbol_left,
    domain: state.config.domain,
    isAdmin: state.navigation.user.isAdmin,
    isLoggedIn: state.navigation.user.isLoggedIn,
    lang: state.lang,
    verticals: state.verticals
});

const mapDispatchToProps = dispatch => {
    return {
        addAssetTag: (assetId, tagId) =>
            dispatch(adminActions.addAssetTag(assetId, tagId)),
        updateTagRanking: (assetId, tagId, tagRanking) =>
            dispatch(adminActions.updateTagRanking(assetId, tagId, tagRanking)),
        toggleAgreedToList: (venueId, agreedToList) =>
            dispatch(adminActions.toggleAgreedToList(venueId, agreedToList)),
        highlightMapMarker: roomId =>
            dispatch(uiActions.toggleRoomHover(roomId)),
        removeAssetTag: (assetId, tagId) =>
            dispatch(adminActions.removeAssetTag(assetId, tagId)),
        toggleAssetImageFlag: (config, assetId, imageId, flagged) =>
            dispatch(adminActions.toggleAssetImageFlag(config, assetId, imageId, flagged)),
        updateRoomVerticalChange: (assetId, verticalId) =>
            dispatch(adminActions.updateRoomVerticalChange(assetId, verticalId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CardHOC);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/CardSlider/CardContainer/Card/CardHOC.jsx